module.exports = __webpack_public_path__ + "img/02-02-img-02.b1a74c8c.png";